import { rotatePoint } from '../../store/form/utils';

export default function ElementValidity({ element }, ref: any) {
  const font = `${element.fontFamily}-${element.fontWeight}`;
  const canvas = ref.current;
  const ctx = canvas.getContext('2d');
  const width = canvas.width;
  const height = canvas.height;
  const aspectRatio = width / height;
  const eWidth = (element.width * width) / 1000;
  const eHeight = ((element.height * height) / 1000) * aspectRatio;
  const top = ((element.top * height) / 1000) * aspectRatio;
  const left = (element.left * width) / 1000;
  const text = 'VALIDADE';
  let fontSize = 1;
  ctx.font = `${fontSize}px ${font}`;
  const mText = `${text} __ __ ____`;
  let measure = ctx.measureText(mText);
  while (measure.width < eWidth && fontSize < eHeight) {
    fontSize++;
    ctx.font = `${fontSize}px ${font}`;
    measure = ctx.measureText(mText);
  }
  fontSize--;

  // ctx.fillStyle = "rgba(0, 255, 0, 0.3)";
  // ctx.fillRect(left, top, eWidth, eHeight);
  ctx.font = `${fontSize}px ${font}`;
  ctx.fillStyle = 'black';
  ctx.fillText(`${text}`, left, top + fontSize);
  const dimText = ctx.measureText(text);
  let dimLine = ctx.measureText('__');
  const dimSpace = ctx.measureText(' ');
  const lineWidth = 2;
  const rotate = 15;
  const offsetY = fontSize * 0.15;
  const point1 = {
    x: left + dimSpace.width + dimText.width,
    y: top + fontSize + offsetY,
  };
  const point2 = {
    x: point1.x + dimSpace.width + dimLine.width,
    y: point1.y,
  };
  const point3 = {
    x: point2.x + dimSpace.width + dimLine.width,
    y: point2.y,
  };

  const date = element.text.split('/');
  const day = date[0] ?? '';
  const month = date[1] ?? '';
  const year = date[2] ?? '';
  const dimDay = ctx.measureText(day);
  const dimMonth = ctx.measureText(month);
  const dimYear = ctx.measureText(year);

  ctx.fillText(
    day,
    point1.x + (dimLine.width - dimDay.width) / 2,
    point1.y - offsetY,
  );

  ctx.fillText(
    month,
    point2.x + (dimLine.width - dimMonth.width) / 2,
    point2.y - offsetY,
  );

  ctx.beginPath();
  ctx.moveTo(point1.x, point1.y);
  ctx.lineTo(point1.x + dimLine.width, point1.y);
  const p1 = rotatePoint(
    {
      x: point1.x + dimLine.width,
      y: point1.y - fontSize - offsetY,
    },
    {
      x: point1.x + dimLine.width,
      y: point1.y,
    },
    rotate,
  );
  ctx.lineTo(p1.x, p1.y);
  ctx.lineWidth = lineWidth;
  ctx.strokeStyle = 'black';
  ctx.stroke();

  ctx.beginPath();
  ctx.moveTo(point2.x, point2.y);
  ctx.lineTo(point2.x + dimLine.width, point2.y);
  const p2 = rotatePoint(
    {
      x: point2.x + dimLine.width,
      y: point2.y - fontSize - offsetY,
    },
    {
      x: point2.x + dimLine.width,
      y: point2.y,
    },
    rotate,
  );
  ctx.lineTo(p2.x, p2.y);
  ctx.stroke();

  dimLine = ctx.measureText('____');
  ctx.fillText(
    year,
    point3.x + (dimLine.width - dimYear.width) / 2,
    point3.y - offsetY,
  );

  ctx.moveTo(point3.x, point3.y);
  ctx.lineTo(point3.x + dimLine.width, point3.y);
  ctx.stroke();
}
